
import Linkify from 'react-linkify';

const LinkifyText = props => {
  const CustomLink = ({ href, children, key }) => (
    <a
      key={key}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      {children}
    </a>
  );

  const componentDecorator = (decoratedHref, decoratedText, key) => {
    return <CustomLink key={key} href={decoratedHref}>{decoratedText}</CustomLink>;
  };

  return (
    <Linkify componentDecorator={componentDecorator}>
      { props.children }
    </Linkify>
  )
}

export default LinkifyText;